import { eventChannel, buffers } from 'redux-saga'
import {
    select, take, put, call, takeEvery,
} from 'redux-saga/effects'

import InternalCommunication from 'common/services/comms/Internal'

import Zoid from 'common/modules/zoid'
import { creators, types } from 'common/modules/internal/actions'
import selectors from 'common/modules/internal/selectors'

import { ARBITER_TAG } from 'common/tags'

const createInternalWatcher = (channel) => eventChannel((emitter) => {
    const handler = (message) => {
        emitter(message)
    }

    channel.addEventListener('message', handler)

    return () => {
        channel.removeEventListener('message', handler)
    }
}, buffers.expanding(5))

export function* watchInternalMessages({ payload }) {
    const channelId = yield select(Zoid.selectors.getChannelId)
    const { tag } = payload

    const channel = InternalCommunication(channelId)

    yield put(yield call(creators.listen, { payload: { channel, origin: tag } }))

    const internalChannel = yield call(createInternalWatcher, channel)

    channel.postMessage({
        target: ARBITER_TAG,
        origin: tag,
        type: 'FRAME/INIT',
        frame: tag,
    })

    while (true) {
        try {
            const incoming = yield take(internalChannel)

            const { target, origin, ...message } = incoming

            if (target === tag || (target === '*' && origin !== tag)) {
                yield put(creators.receivedMessage({ payload: incoming }))

                yield put({ ...message })
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('internal channel error:', err)
            internalChannel.close()
        }
    }
}

export function* watchSendMessage({ payload }) {
    const channel = yield select(selectors.getChannel)
    const origin = yield select(selectors.getOrigin)

    channel.postMessage({ ...payload, origin })
}

export function* takes() {
    yield takeEvery(Zoid.types.ZOID_INIT_SUCCESS, watchInternalMessages)
    yield takeEvery(types.INTERNAL_SEND_MESSAGE, watchSendMessage)
}

const sagas = {
    takes,
}

export default sagas
